import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=2cb39aed&"
import script from "./RegisterView.vue?vue&type=script&lang=ts&"
export * from "./RegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports